import EndPointTypes from 'interfaces/EndPointTypes';
import { AuthProtect } from '@/common/enum';

const positionsEndpoint = import.meta.env.VITE_POSITIONS_API_ENDPOINT;

export const fetchPositions = (ids: string): EndPointTypes => ({
  authorization: AuthProtect.REQUIRED,
  method: 'GET',
  url: 'api/permissions/position',
  defaultBaseURL: positionsEndpoint,
  params: { positionIDs: ids },
});